'use es6';

import { DAYS, HOURS, MINUTES, SECONDS, formatDurationToMilliseconds, formatDurationToUnit, getDefaultUnit } from '../../utilities/durationUtilities';
import FilterOperatorErrorType from 'customer-data-filters/components/propTypes/FilterOperatorErrorType';
import I18n from 'I18n';
import PropTypes from 'prop-types';
import { useState } from 'react';
import { syntheticEvent } from 'foundations-components/transitional/utils/SyntheticEvent';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UIInputGroup from 'UIComponents/form/UIInputGroup';
import UINumberInput from 'UIComponents/input/UINumberInput';
import UISelect from 'UIComponents/input/UISelect';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FilterOperatorDurationInput = props => {
  const {
    className,
    'data-selenium-test': dataSeleniumTest,
    error,
    onBlur,
    onChange,
    value: initialDuration
  } = props;
  const isError = error.get('error');
  const errorMessage = error.get('message');
  const initialUnit = getDefaultUnit(initialDuration);
  const [durationInput, updateDurationInput] = useState(formatDurationToUnit(initialDuration, initialUnit));
  const [currentUnit, updateCurrentUnit] = useState(initialUnit);
  const langKey = 'customerDataFilters.FilterOperatorDurationInput.DurationUnits';
  const DurationUnitOptions = [{
    text: I18n.text(`${langKey}.seconds`, {
      count: durationInput || 0
    }),
    value: SECONDS
  }, {
    text: I18n.text(`${langKey}.minutes`, {
      count: durationInput || 0
    }),
    value: MINUTES
  }, {
    text: I18n.text(`${langKey}.hours`, {
      count: durationInput || 0
    }),
    value: HOURS
  }, {
    text: I18n.text(`${langKey}.days`, {
      count: durationInput || 0
    }),
    value: DAYS
  }];
  const handleValueChange = event => {
    const {
      target: {
        value
      }
    } = event;
    if (typeof value !== 'number') {
      onChange(syntheticEvent(null));
      return;
    }
    const valueInMilliseconds = Math.floor(formatDurationToMilliseconds(value, currentUnit));
    updateDurationInput(value);
    onChange(syntheticEvent(valueInMilliseconds));
  };
  const handleUnitChange = event => {
    const {
      target: {
        value
      }
    } = event;
    updateCurrentUnit(value);
    if (typeof durationInput !== 'number') {
      onChange(syntheticEvent(null));
      return;
    }
    const valueInMilliseconds = Math.floor(formatDurationToMilliseconds(durationInput, value));
    onChange(syntheticEvent(valueInMilliseconds));
  };
  return /*#__PURE__*/_jsxs(UIInputGroup, {
    className: className,
    use: "itemBoth",
    children: [/*#__PURE__*/_jsx(UIFormControl, {
      error: isError,
      style: {
        flexGrow: 1
      },
      validationMessage: isError ? errorMessage : null,
      children: /*#__PURE__*/_jsx(UINumberInput, {
        "data-selenium-info": "duration",
        "data-selenium-test": dataSeleniumTest,
        formatter: value => value != null ? I18n.formatNumber(value, {
          precision: 3
        }) : '',
        onBlur: onBlur,
        onChange: handleValueChange,
        value: durationInput
      })
    }), /*#__PURE__*/_jsx(UIFormControl, {
      children: /*#__PURE__*/_jsx(UISelect, {
        clearable: false,
        "data-selenium-info": "unit",
        "data-selenium-test": dataSeleniumTest,
        onChange: handleUnitChange,
        options: DurationUnitOptions,
        value: currentUnit
      })
    })]
  });
};
FilterOperatorDurationInput.propTypes = {
  className: PropTypes.string,
  'data-selenium-test': PropTypes.string,
  error: FilterOperatorErrorType.isRequired,
  onBlur: PropTypes.func,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number
};
export default FilterOperatorDurationInput;